import styles from './Tag.module.css'

/**
 * Small monospace chip used for tech stacks and skill items.
 *
 * @param {'default'|'accent'} tone
 */
const Tag = ({ children, tone = 'default', className = '' }) => (
  <li className={`${styles.tag} ${styles[tone]} ${className}`.trim()}>{children}</li>
)

export default Tag
